module.exports = __webpack_public_path__ + "img/6.eb454bd2.png";